// ─── Robot Identity Enums (match proto RobotType.proto) ──────────────────────

export enum RobotTypeEnum {
  Unknown = 0,
  Aerial = 1,
  Quadruped = 2,
  Wheeled = 3,
  Wearable = 9001,
}

export enum RobotModelEnum {
  Unknown = 0,
  spot = 1,
  matrice_4td = 2,
  magni = 3,
  anymal = 4,
  turtlebot = 5,
  generic_quadcopter = 6,
  generic_rover = 7,
  rb_watcher = 8,
  smartphone = 9001,
}

export enum RobotManufacturerEnum {
  Unknown = 0,
  BostonDynamics = 1,
  Dji = 2,
  Ubiquity = 3,
  ANYbotics = 4,
  ROBOTIS = 5,
  Px4 = 6,
  Ardupilot = 7,
  Robotnik = 8,
  Misc = 9001,
}

// ─── Robot Model Config ──────────────────────────────────────────────────────

export type RobotModelConfig = {
  robotModel: RobotModelEnum;
  robotType: RobotTypeEnum;
  manufacturer: RobotManufacturerEnum;
  /** Whether this model uses the new ROS abstraction layer */
  usesRosAbstraction: boolean;
};
